export default __webpack_public_path__ + "static/media/bhojpuri_lang.a832226d.png";